import { render } from "./StatusLabel.vue?vue&type=template&id=a41dbe84&scoped=true"
import script from "./StatusLabel.vue?vue&type=script&lang=js"
export * from "./StatusLabel.vue?vue&type=script&lang=js"

import "./StatusLabel.vue?vue&type=style&index=0&id=a41dbe84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41dbe84"]])

export default __exports__